// @ vendors
const { Promise } = require('es6-promise');
const { isEmpty, get } = require('lodash');

// @ utilities
const { recordProcess, PROC_FAIL, PROC_END } = require('utilities/tagging');

// @ track processes
const { PROC_ADD_CO_HOLDER, PROC_CHANGE_HOLDER_DATA } = require('constants/mortgageRequestProcesses');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

//@actions
const { requestState } = require('actions/mortgageRequest/mortgageRequestState');
const { validateHolderStep, getNextStepValid } = require('actions/mortgageRequest/mortgageHoldersDataValidation');
const { getHoldersPersonalAndEconomicData } = require('actions/mortgageRequest/mortgageRequestViewProcess');

// @ constants
const {
    MORTGAGE_REQUEST_HOLDER_RESET,
    MORTGAGE_REQUEST_HOLDER_REQUEST,
    MORTGAGE_REQUEST_HOLDER_SUCCESS,
    MORTGAGE_REQUEST_HOLDER_FAILURE,
    MORTGAGE_REQUEST_EDIT_HOLDER_REQUEST,
    MORTGAGE_REQUEST_EDIT_HOLDER_SUCCESS,
    MORTGAGE_REQUEST_EDIT_HOLDER_FAILURE,
    MORTGAGE_REQUEST_EDIT_COHOLDER_RESET,
    MORTGAGE_REQUEST_EDIT_COHOLDER_REQUEST,
    MORTGAGE_REQUEST_EDIT_COHOLDER_SUCCESS,
    MORTGAGE_REQUEST_EDIT_COHOLDER_FAILURE,
    MORTGAGE_REQUEST_HOLDER_ID_SET,
    MORTGAGE_REQUEST_HOLDER_FLAG,
    MORTGAGE_REQUEST_HOLDER_EDIT_SET_FIELD,
    MORTGAGE_REQUEST_HOLDER_EDIT_ADD_FILE,
    MORTGAGE_REQUEST_HOLDER_EDIT_UPLOAD_FILE_ERROR,
    MORTGAGE_REQUEST_HOLDER_EDIT_UPLOAD_FILE_REQUEST,
    MORTGAGE_REQUEST_HOLDER_EDIT_UPLOAD_FILE_SUCCESS,
    MORTGAGE_REQUEST_ADD_COHOLDER_REQUEST,
    MORTGAGE_REQUEST_ADD_COHOLDER_SUCCESS,
    MORTGAGE_REQUEST_ADD_COHOLDER_FAILURE,
} = require('constants/actionTypes');

const resetState = () => ({
    type: MORTGAGE_REQUEST_HOLDER_RESET
});

const resetCoHolderState = () => ({
    type: MORTGAGE_REQUEST_EDIT_COHOLDER_RESET
});

const reset = () => dispatch => {
    dispatch(resetState());
};

const resetCoHolder = () => dispatch => {
    dispatch(resetCoHolderState());
};

const requestHolderInProgress = (holderId) => ({
    type: MORTGAGE_REQUEST_HOLDER_REQUEST,
    requestedId: holderId
});

const requestHolderSuccess = (data, identificador, tipoDocumentoIdentidad) => ({
    type: MORTGAGE_REQUEST_HOLDER_SUCCESS,
    data: data,
    identificador: identificador,
    tipoDocumentoIdentidad: tipoDocumentoIdentidad
});

const requestHolderFailure = (error) => ({
    type: MORTGAGE_REQUEST_HOLDER_FAILURE,
    data: {
        error
    }
});

const addFile = data => ({
    type: MORTGAGE_REQUEST_HOLDER_EDIT_ADD_FILE,
    data
});

const editHolderInProgress = () => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_REQUEST
});

const editHolderSuccess = () => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_SUCCESS
});

const editHolderFailure = (error) => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_FAILURE,
    data: {
        error
    }
});

const editCoHolderInProgress = () => ({
    type: MORTGAGE_REQUEST_EDIT_COHOLDER_REQUEST
});

const editCoHolderSuccess = () => ({
    type: MORTGAGE_REQUEST_EDIT_COHOLDER_SUCCESS
});

const editCoHolderFailure = (error) => ({
    type: MORTGAGE_REQUEST_EDIT_COHOLDER_FAILURE,
    data: {
        error
    }
});

const requestHolderIdSet = (holderId) => ({
    type: MORTGAGE_REQUEST_HOLDER_ID_SET,
    requestedId: holderId
});

const requestHolderFlag = () => ({
    type: MORTGAGE_REQUEST_HOLDER_FLAG
});

const setField = (inputField, data) => ({
    type: MORTGAGE_REQUEST_HOLDER_EDIT_SET_FIELD,
    payload: {
        inputField,
        data
    }
});

const uploadFileError = data => ({
    type: MORTGAGE_REQUEST_HOLDER_EDIT_UPLOAD_FILE_ERROR,
    data
});

const requestHolderEditUploadFilesInProgress = () => ({
    type: MORTGAGE_REQUEST_HOLDER_EDIT_UPLOAD_FILE_REQUEST
});

const requestHolderEditUploadSuccess = () => ({
    type: MORTGAGE_REQUEST_HOLDER_EDIT_UPLOAD_FILE_SUCCESS
});

const requestAddCoHolderInProgress = () => ({
    type: MORTGAGE_REQUEST_ADD_COHOLDER_REQUEST
});

const requestAddCoHolderSuccess = () => ({
    type: MORTGAGE_REQUEST_ADD_COHOLDER_SUCCESS
});

const requestAddCoHolderFailure = error => ({
    type: MORTGAGE_REQUEST_ADD_COHOLDER_FAILURE,
    data: {
        error
    }
});

const requestHolder = holderId => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolder;
    if (!currentState.get('isFetching')) {
        const documentoDeIdentidad = holderId.split('-');
        let identificador = '';
        let tipoDocumentoIdentidad = '';
        if (documentoDeIdentidad.length === 2) {
            tipoDocumentoIdentidad = documentoDeIdentidad[0];
            identificador = documentoDeIdentidad[1];
        }
        tipoDocumentoIdentidad = !!tipoDocumentoIdentidad ? tipoDocumentoIdentidad.trim() : tipoDocumentoIdentidad;
        const requestData = {
            query: {
                numeroDocumento: identificador,
                tipoDocumentoIdentidad
            }
        };

        dispatch(requestHolderInProgress());
        dispatch(requestHolderIdSet(holderId));
        return APIPost(dispatch, apiURLBuilder.getURL('mortgageRequestHolderInfo'), requestData)
            .then(response => {
                dispatch(requestHolderSuccess(response, identificador, tipoDocumentoIdentidad));
                getHoldersPersonalAndEconomicData(dispatch, getState, true);
            })
            .catch(error => dispatch(requestHolderFailure(error))) //temp error is success, must be requestCoHolderFailure
    } else {
        return Promise.resolve()
    }
};

const editHolderCoHolder = (formData, history) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolder;
    const isAlreadyFetching = currentState.get('isFetching');

    if (!isAlreadyFetching) {
        const expirationDate = new Date(formData.expirationYear, formData.expirationMonth - 1, formData.expirationDay);
        const exDay = expirationDate.getDate();
        const exMonth = expirationDate.getMonth() + 1;
        const exYear = expirationDate.getFullYear();
        const finalEx = exYear + '-' + ('00' + exMonth).slice(-2) + '-' + ('00' + exDay).slice(-2);
        let finalBD;
        if (!formData.isOpenbankClient) {
            const birthday = new Date(formData.year, formData.month - 1, formData.day);
            const bDay = birthday.getDate();
            const bMonth = birthday.getMonth() + 1;
            const bYear = birthday.getFullYear();
            finalBD = bYear + '-' + ('00' + bMonth).slice(-2) + '-' + ('00' + bDay).slice(-2);
        }

        const requestData = {
            query: {
                'documentoDeIdentidad': {
                    'fechaCaducidad': finalEx,
                    'identificador': formData.idDocumentText,
                    'tipoDocumentoIdentidad': formData.idDocument
                },
                'estadoCivil': formData.civilStatus,
                'fechaNacimiento': finalBD,
                'localidad': get(formData.location, 'label', undefined),
                'lugarResidencia': formData.placeResidence,
                'mailAdicional': formData.mailAdicional,
                'mailContacto': formData.mailContacto,
                'nacionalidad': formData.nationality,
                'nombreCompleto': formData.name,
                'numeroPersonasACargo': formData.personsNumber,
                'openbankFl': formData.openbankFl,
                'ordenNm': formData.ordenNm,
                'persdeclfl': formData.persdeclfl,
                'primerApellido': formData.lastname1,
                'codigoProvincia': get(formData.province, 'value', undefined),
                'segundoApellido': formData.lastname2,
                'provincia': get(formData.province, 'label', undefined),
                'tipoVia': formData.typeOfRoad,
                'nombreVia': formData.nameOfRoad,
                'numeroVia': formData.numberOfRoad,
                'codigoPostal': formData.postalCode,
                'telefonoMovil': formData.telefonoMovil
            }
        };
        if (typeof formData.isOpenbankClient !== 'undefined') {
            requestData.query.clienteOpenBank = formData.isOpenbankClient;
        }

        const url = apiURLBuilder.getURL('mortgageRequestHolderInfoEdit');
        (formData.ordenNm === '2') ? dispatch(editCoHolderInProgress()) : dispatch(editHolderInProgress())

        dispatch(requestHolderFlag());
        return APIPost(dispatch, url, requestData)
            .then(() => {
                dispatch(requestHolderIdSet(0));
                if (formData.ordenNm === '2') {
                    dispatch(editCoHolderSuccess());
                    recordProcess(PROC_ADD_CO_HOLDER, PROC_END);
                } else {
                    dispatch(editHolderSuccess());
                    recordProcess(PROC_CHANGE_HOLDER_DATA, PROC_END);
                }
                const holderKey = formData.ordenNm == 2 ? 'isCoHolder' : 'isHolder';
                const holderNumber = parseInt(formData.ordenNm, 10);
                dispatch(validateHolderStep(0, holderKey));
                const linkRedirection = dispatch(getNextStepValid(holderNumber));

                dispatch(requestState(linkRedirection, history));
            })
            .catch(error => {
                if (formData.ordenNm === '2') {
                    recordProcess(PROC_ADD_CO_HOLDER, PROC_FAIL);
                    dispatch(editCoHolderFailure(error));
                } else {
                    recordProcess(PROC_CHANGE_HOLDER_DATA, PROC_END);
                    dispatch(editHolderFailure(error));
                }
                history.push('/myprofile/mortgage-error');
            });
    } else {
        return Promise.resolve()
    }

}

const editHolder = (idExpediente, formData, history) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolder;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        let requestData = {
            'idDocumentText': formData.idDocumentText,
            'idDocument': formData.idDocument,
            'civilStatus': formData.civilStatus,
            'personsNumber': formData.personsNumber,
            'openbankFl': formData.openbankFl,
            'ordenNm': formData.ordenNm,
            'persdeclfl': formData.persdeclfl,
            'expirationYear': formData.expirationYear,
            'expirationMonth': formData.expirationMonth,
            'expirationDay': formData.expirationDay,
        }

        if (typeof formData.isOpenbankClient !== 'undefined' && formData.isOpenbankClient === false) {

            const noClientData = {
                'isOpenbankClient': formData.isOpenbankClient,
                'year': formData.year,
                'month': formData.month,
                'day': formData.day,
                'location': formData.location,
                'placeResidence': formData.placeResidence,
                'nationality': formData.nationality,
                'name': formData.name,
                'lastname1': formData.lastname1,
                'lastname2': formData.lastname2,
                'province': formData.province,
                'typeOfRoad': formData.typeOfRoad,
                'nameOfRoad': formData.nameOfRoad,
                'numberOfRoad': formData.numberOfRoad,
                'postalCode': formData.postalCode
            }
            Object.assign(requestData, noClientData);
        } else {
            Object.assign(requestData, { isOpenbankClient: true });
        }

        dispatch(editHolderCoHolder(requestData, history));

    } else {
        return Promise.resolve()
    }
};

const editCoHolder = (idExpediente, formData, history) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolder;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        let requestData = {
            'idDocumentText': formData.idDocumentText,
            'idDocument': formData.idDocument,
            'civilStatus': formData.civilStatus,
            'personsNumber': formData.personsNumber,
            'openbankFl': formData.openbankFl,
            'ordenNm': formData.ordenNm,
            'persdeclfl': formData.persdeclfl,
            'expirationYear': formData.expirationYear,
            'expirationMonth': formData.expirationMonth,
            'expirationDay': formData.expirationDay,
        }

        if (typeof formData.isOpenbankClient !== 'undefined' && formData.isOpenbankClient === false) {
            const noClientData = {
                'isOpenbankClient': formData.isOpenbankClient,
                'year': formData.year,
                'month': formData.month,
                'day': formData.day,
                'location': formData.location,
                'placeResidence': formData.placeResidence,
                'nationality': formData.nationality,
                'name': formData.name,
                'lastname1': formData.lastname1,
                'lastname2': formData.lastname2,
                'province': formData.province,
                'typeOfRoad': formData.typeOfRoad,
                'nameOfRoad': formData.nameOfRoad,
                'numberOfRoad': formData.numberOfRoad,
                'postalCode': formData.postalCode
            }
            Object.assign(requestData, noClientData);
        } else {
            Object.assign(requestData, { isOpenbankClient: true });
        }

        dispatch(editHolderCoHolder(requestData, history));
    } else {
        return Promise.resolve()
    }
};

const addCoHolderRNCForm = (coHolder, history) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolder;
    const mortgageState = getState().mortgageRequestState;
    if (currentState.get('isFetching')) {
        return Promise.resolve();
    } else {
        const coHolderOb = {
            codigoDocumento: coHolder.documentNumber,
            mail: coHolder.email,
            movil: coHolder.mobileNumber,
            nombre: coHolder.name,
            ordenIntervencion: '1',
            prefijoMovil: coHolder.mobileCountryIndicative.substring(1),
            primerApellido: coHolder.firstLastName,
            segundoApellido: coHolder.secondLastName,
            tipoDocumento: coHolder.documentType,
            tipoIntervencion: '01'
        }

        const requestData = {
            query: {
                noClientInformation: {
                    titulars: [coHolderOb]
                },
                tokenSimulacion: mortgageState.get('token')
            }
        };

        dispatch(requestAddCoHolderInProgress());
        return APIPost({
            dispatch,
            endpoint: 'mortgageRequestAddCoHolderRNCForm',
            params: requestData
        })
            .then(() => {
                dispatch(requestAddCoHolderSuccess());
                recordProcess(PROC_ADD_CO_HOLDER, PROC_END);
                dispatch(requestState('/myprofile/mortgage/panel', history));
            })
            .catch(response => {
                if (!!response.error) {
                    recordProcess(PROC_ADD_CO_HOLDER, PROC_FAIL);
                    dispatch(requestAddCoHolderFailure(response));
                    history.push('/myprofile/mortgage-error');
                } else {
                    throw response;
                }
            });
    }
}

const addCoHolderRNC = (coHolder, history) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolder;
    if (!currentState.get('isFetching')) {
        const coHolderOb = {
            "codigoDocumento": coHolder.documentNumber,
            "mail": coHolder.email,
            "movil": coHolder.mobileNumber,
            "nombre": coHolder.name,
            "ordenIntervencion": "1",
            "prefijoMovil": coHolder.mobileCountryIndicative.substring(1),
            "primerApellido": coHolder.firstLastName,
            "segundoApellido": coHolder.secondLastName,
            "tipoDocumento": coHolder.documentType,
            "tipoIntervencion": "01"
        }

        const coHolderRNC = {
            'isOpenbankClient': false,
            'idDocumentText': coHolder.documentNumber,
            'idDocument': coHolder.documentType,
            'name': coHolder.name,
            'lastname1': coHolder.firstLastName,
            'lastname2': coHolder.secondLastName,
            'expirationYear': coHolder.documentExpirationYear,
            'expirationMonth': coHolder.documentExpirationMonth,
            'expirationDay': coHolder.documentExpirationDay,
            'year': parseInt(coHolder.documentExpirationYear) - 30 + '',
            'month': coHolder.documentExpirationMonth,
            'day': coHolder.documentExpirationDay,
            'ordenNm': '2',
            'civilStatus': 'SOLTERO',
            'mailContacto': coHolder.email,
            'telefonoMovil': coHolder.mobileNumber
        }

        const requestData = {
            query: {
                titulars:
                    [coHolderOb]
            }
        }
        const url = apiURLBuilder.getURL('mortgageRequestAddCoHolder');
        dispatch(requestAddCoHolderInProgress());
        return APIPost(dispatch, url, requestData)
            .then(response => {

                if (response.msg !== '93') {
                    dispatch(requestAddCoHolderSuccess());
                    dispatch(editHolderCoHolder(coHolderRNC, history));
                } else {
                    dispatch(requestAddCoHolderFailure(response.msg));
                    history.push('/myprofile/mortgage-error');
                }
            })
            .catch(error => {
                recordProcess(PROC_ADD_CO_HOLDER, PROC_FAIL);
                dispatch(requestAddCoHolderFailure(error));
                history.push('/myprofile/mortgage-error');
            });
    } else {
        return Promise.resolve()
    }
}


const sendFiles = (idExpediente, data, obj, history) => (dispatch, getState) => {
    const params = {
        index: obj.index || 0,
        documents: obj.documents
    };

    if (params.index < params.documents.length) {
        const formData = new FormData();
        const doc = params.documents[params.index];

        const model = {
            tipoArchivo: doc.fileType,
            idExpediente,
            tipoDocumento: data.idDocument,
            numeroDocumento: data.idDocumentText
        };

        formData.append('files', doc.file);
        formData.append('model', new Blob(
            [JSON.stringify(model)],
            { type: 'application/json' }
        ));

        const requestData = {
            query: formData
        };

        return APIPost({
            dispatch,
            endpoint: 'mortgageRequesWorkDataFileMultipleSubmit',
            params: requestData,
            contentType: false
        })
            .then(() => {
                params.index++;
                dispatch(sendFiles(idExpediente, data, params, history));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(uploadFileError({
                        fileId: doc.fileId,
                        error: response.error
                    }));
                    params.index++;
                    dispatch(sendFiles(idExpediente, data, params, history));
                } else {
                    throw response;
                }
            });
    } else {
        dispatch(requestHolderEditUploadSuccess());
        const holderEditState = getState().mortgageRequestHolderEdit;

        if (holderEditState.get('errorUploading').size === 0 || data.filesValid) {
            dispatch(editHolder(idExpediente, data, history));
        }
    }
};

const uploadFiles = (idExpediente, data, history) => (dispatch, getState) => {
    const holderEditState = getState().mortgageRequestHolderEdit;

    if (!holderEditState.get('isUploading')) {
        const files = holderEditState.getIn(['files']).toJS();

        const documents = [];

        !isEmpty(files) && Object.keys(files).map(key => {
            documents.push({
                fileType: key,
                file: files[key].file
            })
        });

        dispatch(requestHolderEditUploadFilesInProgress());
        dispatch(sendFiles(idExpediente, data, {
            documents,
        }, history));
    }
};


module.exports = {
    requestHolder,
    editHolder,
    editCoHolder,
    reset,
    resetCoHolder,
    setField,
    addFile,
    uploadFiles,
    addCoHolderRNC,
    addCoHolderRNCForm
};
